var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
var TeamMember = require('./team-member');
var ColumnList = require('./column-list');

var TeamMemberList = createClass({

  propTypes: {
    members: PropTypes.array
  },

  render() {
    var memberNodes = this.props.members.map(function(member, index) {
      return (
        <TeamMember index={index} name={member.name} title={member.title} photo={member.photo}/>
      );
    });
    return (
      <ColumnList elements={memberNodes} />
    );
  }
});

module.exports = TeamMemberList;
